export default "images/default.jpg";